import { Exercise } from '../../../entities/exercise/exercise';
import { DbExerciseRepository } from './db-exercise-repository';

// todo add better fallback exercises
// TODO: no unique reference in the data, so nothing gets returned after it is inserted
const fallbackDataJson: string = `[
  {"name":"Ab Crunch","level":["Beginner","Intermediate"],"bagContact":true,"cardioOrResistance":"Cardio",
  "bodyGroups":["Abdomen"],"compatibleZones":[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20],"similarityCode":[1]},
  {"name":"Burbee","level":["Expert"],"bagContact":true,"cardioOrResistance":"Cardio",
  "bodyGroups":["Abdomen"],"compatibleZones":[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20],"similarityCode":[2]},
  {"name":"Cleans","level":["Beginner"],"bagContact":true,"cardioOrResistance":"Cardio",
  "bodyGroups":["Abdomen"],"compatibleZones":[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20],"similarityCode":[3]},
  {"name":"Deadlift","level":["Beginner"],"bagContact":true,"cardioOrResistance":"Resistance",
  "bodyGroups":["Abdomen"],"compatibleZones":[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20],"similarityCode":[5]},
  {"name":"Elbow Plan","level":["Intermediate"],"bagContact":true,"cardioOrResistance":"Cardio",
  "bodyGroups":["Abdomen"],"compatibleZones":[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20],"similarityCode":[6]},
  {"name":"Flys","level":["Expert"],"bagContact":true,"cardioOrResistance":"Cardio",
  "bodyGroups":["Abdomen"],"compatibleZones":[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20],"similarityCode":[7]},
  {"name":"Goblet Squat","level":["Beginner"],"bagContact":true,"cardioOrResistance":"Cardio",
  "bodyGroups":["Abdomen"],"compatibleZones":[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20],"similarityCode":[8]},
  {"name":"Hammer Curl","level":["Beginner"],"bagContact":true,"cardioOrResistance":"Resistance",
  "bodyGroups":["Abdomen"],"compatibleZones":[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20],"similarityCode":[9]},
  {"name":"Incline Curl","level":["Expert"],"bagContact":true,"cardioOrResistance":"Cardio",
"bodyGroups":["Abdomen"],"compatibleZones":[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20],"similarityCode":[10]},
  {"name":"Jab Bag","level":["Intermediate"],"bagContact":true,"cardioOrResistance":"Cardio",
"bodyGroups":["Abdomen"],"compatibleZones":[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20],"similarityCode":[11]},
{"name":"Warmup1","level":["Intermediate"],"bagContact":false,"cardioOrResistance":"Cardio",
"bodyGroups":["Abdomen"],"compatibleZones":[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20],"similarityCode":[11],
"exerciseFormats": ["WUModBurn"]}]
      `;

// add dummy exercises to DB if it does not exist yet
export class DbExerciseRepositoryWithFallbackData extends DbExerciseRepository {
  constructor(db: any) {
    super(db);
  }

  public async getAll(): Promise<Exercise[]> {
    let allFromDB = await super.getAll();

    if (allFromDB.length === 0) {
        await super.importJsonString(fallbackDataJson);
        allFromDB = await super.getAll();
    }
    return allFromDB;
  }

}
